export default "__VITE_ASSET__BS41yZY3__"